const indexItems = [
  { title: '热血日漫专区', desc: '少年Jump系经典与最新连载', count: '8,520', icon: 'ri-fire-line', color: 'primary' },
  { title: '恋爱甜宠韩漫', desc: '高颜值CP与心动剧情合集', count: '6,340', icon: 'ri-heart-line', color: 'secondary' },
  { title: '国漫古风武侠', desc: '中式美学与江湖侠义之作', count: '4,180', icon: 'ri-sword-line', color: 'accent' },
  { title: '悬疑推理漫选', desc: '烧脑剧情与精妙推理荟萃', count: '3,920', icon: 'ri-search-eye-line', color: 'primary' },
  { title: '搞笑日常系列', desc: '轻松治愈的欢乐喜剧漫画', count: '5,670', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { title: '奇幻异世界', desc: '转生冒险与魔法奇遇之旅', count: '7,210', icon: 'ri-magic-line', color: 'secondary' },
  { title: '校园青春漫', desc: '青涩校园与成长物语精选', count: '4,890', icon: 'ri-school-line', color: 'primary' },
  { title: '科幻未来志', desc: '未来科技与星际冒险盛宴', count: '3,450', icon: 'ri-rocket-line', color: 'accent' },
  { title: '恐怖灵异馆', desc: '细思极恐的惊悚漫画合集', count: '2,780', icon: 'ri-ghost-line', color: 'secondary' },
];

const colorMap: Record<string, { badge: string; iconBg: string; iconText: string }> = {
  primary: { badge: 'bg-primary-100 text-primary-700', iconBg: 'bg-primary-100', iconText: 'text-primary-500' },
  secondary: { badge: 'bg-secondary-100 text-secondary-700', iconBg: 'bg-secondary-100', iconText: 'text-secondary-500' },
  accent: { badge: 'bg-accent-100 text-accent-700', iconBg: 'bg-accent-100', iconText: 'text-accent-500' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          漫画分类索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按题材快速定位你的下一个心头好
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => {
            const c = colorMap[item.color];
            return (
              <div
                key={item.title}
                className="flex items-center gap-3 bg-background-50 rounded-xl border border-background-200/80 p-4 cursor-pointer hover:border-primary-200/60 transition-colors"
              >
                <div className={`w-10 h-10 rounded-xl ${c.iconBg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} ${c.iconText} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-0.5">
                    <h3 className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.title}</h3>
                    <span className={`text-xs px-1.5 py-0.5 rounded-md ${c.badge} whitespace-nowrap`}>{item.count}部</span>
                  </div>
                  <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}